import { ReactComponent as CircleInfo } from '@keahotels/assets/icons/CircleInfo.svg';
import styles from './BookingSearchResults.module.css';

import { ReactNode } from 'react';

export type BookingResultErrorProps = {
	hasError: boolean;
	children: ReactNode;
};

export default function BookingResultError({
	hasError,
	children,
}: BookingResultErrorProps) {
	if (!hasError) return null;
	return (
		<div className={styles.noResults}>
			<CircleInfo className={styles.noResultsIcon} />
			{children}
		</div>
	);
}
